<template>
    <div class="notfound">
        <header-component :is-soon="false" :is-not-found="true" :progression="false" img-left="/trocachip/img/default.png" img-right="/trocachip/img/access.svg" />
        <div class="notfound_card">
            <section class="notfound_type">
                <i class="notfound_danger"></i>
            </section>
            <h2 class="notfound_description">
                Não foi possível acessar o portal Troca de Chip
            </h2>
            <p class="notfound_message">Por favor, tente novamente mais tarde.</p>
            <div class="notfound_container_button">
                <button
                    ref="action-button"
                    class="notfound_btn_close_button"
                    @click.prevent="onGoBack"
                >Voltar</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import HeaderComponent from "../components/HeaderComponent";
    import trackEvent from "../services/trackEvent";

    export default {
        name: "NotFound",
        computed: {
            ...mapState({
                customer: state => state.customer
            })
        },
        methods: {
            navigateBack() {
                this.$router.go(-2)
            },
            trackGoBack() {
                const trackData = {
                    'user': {
                        'login': '',
                        'loginType': '',
                        'lineType': '',
                        'segment': '',
                        'subSegment': '',
                        'planCode': '',
                        'planName': ''
                    },
                    'channel': {
                        'name': '7'
                    },
                    'event-category': 6,
                    'event-label': 'Troca de Chip Fora Da Rede Tim',
                    'event-value': null,
                    'event-status': 'Sucesso',
                    'event-interactionNumber': '',
                    'event-error': ''
                }

                if (this.customer && Object.keys(this.customer).length > 0) {
                    trackData.user.login = this.customer.login
                    trackData.user.loginType = this.customer.loginType
                    trackData.user.lineType = this.customer.lineType
                    trackData.user.segment = this.customer.segment
                    trackData.user.subSegment = this.customer.subSegment
                    trackData.user.planCode = this.customer.planCode
                    trackData.user.planName = this.customer.planName
                }

                trackEvent.track(trackData)
            },
            onGoBack() {
              trackEvent.track({
                'user': {
                  'login': this.customer.login,
                  'loginType':  '',
                  'lineType':  this.customer.loginType,
                  'segment': this.customer.segment,
                  'subSegment':  this.customer.subSegment,
                  'planCode': this.customer.planCode,
                  'planName':  this.customer.planName
                },
                'channel': trackEvent.getChannel(),
                'event-category': 6,
                'event-label': "Troca de Chip Fora Da Rede Tim",
                'event-value': null,
                'event-status': 'Sucesso',
                'event-interactionNumber': '',
                'event-error': '',
                'event-errorDetail': ''
              })
                this.navigateBack()
            }
        },
        components: {
            HeaderComponent
        }
    }
</script>

<style lang="scss" scoped>
    .notfound {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        position: relative;
        top: 0;
        left: 0;
        overflow-y: auto;
        background-color: #ffffff;
        > .notfound_card {
            width: 100%;
            min-height: 526px;
            position: relative;
            display: block;
            margin: 0 auto;
            > .notfound_close {
                width: 100%;
                height: 17px;
                margin: 25px auto;
                display: block;
                position: relative;
                z-index: 2;
                > .notfound_btn_close {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close.svg") no-repeat;
                    border: 0;
                    margin-right: 25px;
                }
            }
            > .notfound_type {
                width: 100%;
                height: 60px;
                display: block;
                position: relative;
                margin-top: 40px;
                > .notfound_success {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/path.png") no-repeat;
                    background-position: center;
                }
                > .notfound_danger {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/danger.svg") no-repeat;
                    background-position: center;
                }
                > .notfound_warning {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/ic-exclamation.svg") no-repeat;
                    background-position: center;
                }
            }
            > .notfound_description {
                width: 258px;
                height: 120px;
                margin: 37px auto 0 auto;
                font-family: 'timsans_thin';
                font-size: 2em;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #000000;
            }
            > .notfound_message {
                width: 240px;
                height: 72px;
                display: block;
                margin: 24px auto 0 auto;
                font-family: 'timsans_regular';
                font-size: 1em;
                line-height: 1.5;
                letter-spacing: -0.2px;
                text-align: center;
                color: #666666;
            }
            > .notfound_container_button {
                width: 100%;
                height: auto;
                display: block;
                position: relative;
                margin-top: 40px;
                > .notfound_btn_close_button {
                    width: 286px;
                    min-height: 52px;
                    margin: 0 auto;
                    padding: 16px 0;
                    position: relative;
                    display: grid;
                    border-radius: 26px;
                    box-sizing: border-box;
                    background-color: #003091;
                    color: #ffffff;
                    border: none;
                    font-family: 'timsans_regular';
                    font-size: 1em;
                    text-align: center;
                }
            }
        }
    }
</style>
